import Login from 'components/Login'
import React from 'react'

const LoginPage = () => <Login />

export default LoginPage
